import { Outlet } from "react-router-dom";
import { useLayoutEffect, useContext } from "react";
import NavBar from "./Navbar";
import { Store } from "../App";

function MainLayout() {
  const { isAuth } = useContext(Store);

  return (
    <div className="relative bg-[#110128] min-h-screen overflow-hidden">
      {/* Sticky Navbar */}
      <div className="sticky top-0 z-50">
        <NavBar isAuth={isAuth} />
      </div>

      {/* Main Content */}
      <Main />
    </div>
  );
}

function Main() {
  useLayoutEffect(() => {
    const mainContainer = document.getElementById("main-container");
    mainContainer?.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return (
    <div
      id="main-container"
      className="overflow-y-scroll h-[calc(100vh-4rem)] pb-52 scrollbar-hidden"
    >
      <Outlet />
    </div>
  );
}

export default MainLayout;
